import React, { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { IconButton } from "@evergis/ui";

import { FeatureCardContext } from "./FeatureCardContext";
import { FeatureCardButtonsContainer } from "../../styled";

export const FeatureCardButtons: FC = () => {
  const { feature, coordinates, closeCard, zoomToFeature } = useContext(FeatureCardContext);
  const { t } = useTranslation("featureCard");

  return (
    <FeatureCardButtonsContainer>
      {coordinates && <IconButton kind={"zoom_to"} title={t("zoomToFeature")} onClick={() => zoomToFeature(feature)} />}
      <IconButton kind={"close"} onClick={closeCard} />
    </FeatureCardButtonsContainer>
  );
};
